var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.90817 0 0 2.85593 0 6.375C0 8.73631 0.812195 9.47421 5.12115 16.2504C5.7571 17.2505 7.24361 17.2493 7.87881 16.2504C12.19 9.47066 13 8.73584 13 6.375C13 2.85225 10.0881 0 6.5 0ZM6.5 15.4062C2.18617 8.62239 1.625 8.19413 1.625 6.375C1.625 3.73439 3.80761 1.59375 6.5 1.59375C9.19239 1.59375 11.375 3.73439 11.375 6.375C11.375 8.18633 10.8616 8.54731 6.5 15.4062ZM3.79167 6.375C3.79167 4.90799 5.00422 3.71875 6.5 3.71875C7.99578 3.71875 9.20833 4.90799 9.20833 6.375C9.20833 7.84201 7.99578 9.03125 6.5 9.03125C5.00422 9.03125 3.79167 7.84201 3.79167 6.375Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5dc7a4a4.svg";
export { ForwardRef as ReactComponent };